import React from "react";
import { useTranslation } from "react-i18next";
import PersonalDetailsContainer from "./PersonalDetailsContainer";
import { COUNTRY_NAME } from "../Common/constants";
import { GET_FUNCTION_LIST } from "../Common/utils";
import { useFeatureFlag } from "../../util/oneXp/useFeatureFlag";
import { FEATURE_FLAG_NAMES } from "../../util/oneXp/featureFlagNames";

const AddAccessArray = (props) => {
  const { t } = useTranslation("common");
  const modifyUser = props.modifyUser ? true : false;
  const { enabled: isEurzoneSingaporeChangesEnabled } = useFeatureFlag(
    FEATURE_FLAG_NAMES.GES_EUROZONE_SINGAPORE_COMPLIANCE,
  );

  const accesses = [
    {
      country: t("access.INDIA"),
      controlAccountNumber: "123456789012",
      functions: [
        {
          functionName: t("products.functname1"),
          docName: "user2_access1_function1.pdf",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname2"),
          docName: "",
          message: "",
          roles: [
            {
              roleName: t("products.role-initiator"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.role-approver"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
              message: t("info.caa"),
            },
          ],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname4"),
          docName: "",
          message: t("info.cmr"),
          roles: [
            {
              roleName: t("products.cmrpa"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
              message:
                "This will automatically give you access to CMR Reporting",
            },
            {
              roleName: t("products.3pa"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
          ],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname5"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname6"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.function11"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.function12"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname10"),
          docName: "",
          message: "",
          roles: [
            {
              roleName: t("products.role-pa"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.cardmem"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.cardmanager"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.bcamem"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.sysadmin"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
          ],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
      ],
    },

    {
      country: t("access.AUSTRALIA"),
      controlAccountNumber: "123456789012",
      functions: [
        {
          functionName: t("products.functname1"),
          docName: "user2_access1_function1.pdf",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname2"),
          docName: "",
          message: "",
          roles: [
            {
              roleName: t("products.role-initiator"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.role-approver"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
              message: t("products.role-india"),
            },
          ],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname3"),
          docName: "user2_access1_function1.pdf",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname4"),
          docName: "",
          message: t("info.cmr"),
          roles: [
            {
              roleName: t("products.cmrpa"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
              message: t("info.cmrpa"),
            },
            {
              roleName: t("products.3pa"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
          ],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname5"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname6"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.function11"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.function12"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname9"),
          docName: "",
          message: "",
          roles: [
            {
              roleName: t("products.pafull"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
              message: t("info.pa"),
            },
            {
              roleName: t("products.pacom"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
          ],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname12"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname10"),
          docName: "",
          message: "",
          roles: [
            {
              roleName: t("products.role-pa"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.cardmem"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.cardmanager"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.bcamem"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.sysadmin"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
          ],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
      ],
    },

    {
      country: t("access.HONGKONG"),
      controlAccountNumber: "123456789012",
      functions: [
        {
          functionName: t("products.functname1"),
          docName: "user2_access1_function1.pdf",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname5"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname6"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.function11"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.function12"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname10"),
          docName: "",
          message: "",
          roles: [
            {
              roleName: t("products.role-pa"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.cardmem"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.cardmanager"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.bcamem"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.sysadmin"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
          ],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
      ],
    },

    {
      country: t("access.JAPAN"),
      controlAccountNumber: "123456789012",
      functions: [
        {
          functionName: t("products.functname1"),
          docName: "user2_access1_function1.pdf",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname2"),
          docName: "",
          message: t("info.caa3"),
          roles: [
            {
              roleName: t("products.role-initiator"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.role-approver"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
              message: "",
            },
          ],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },

        {
          functionName: t("products.function11"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.function12"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.cs"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname10"),
          docName: "",
          message: "",
          roles: [
            {
              roleName: t("products.role-pa"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.cardmem"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.cardmanager"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.bcamem"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.sysadmin"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
          ],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname15"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
      ],
    },

    {
      country: t("access.SINGAPORE"),
      controlAccountNumber: "123456789012",
      functions: [
        {
          functionName: t("products.functname1"),
          docName: "user2_access1_function1.pdf",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname2"),
          docName: "",
          message: isEurzoneSingaporeChangesEnabled ? t("info.caa3Singapore") : t("info.caa3"),
          roles: [
            {
              roleName: t("products.role-initiator"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.role-approver"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
              message: "",
            },
          ],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname4"),
          docName: "",
          message: t("info.cmr"),
          roles: [
            {
              roleName: t("products.cmrpa"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
              message: t("info.cmrpa"),
            },
            {
              roleName: t("products.3pa"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
          ],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname5"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname6"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.function11"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.function12"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname10"),
          docName: "",
          message: "",
          roles: [
            {
              roleName: t("products.role-pa"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.cardmem"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.cardmanager"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.bcamem"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.sysadmin"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
          ],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
      ],
    },

    {
      country: t("access.THAILAND"),
      controlAccountNumber: "123456789012",
      functions: [
        {
          functionName: t("products.function11"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.function12"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname10"),
          docName: "",
          message: "",
          roles: [
            {
              roleName: t("products.role-pa"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.cardmem"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.cardmanager"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.bcamem"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.sysadmin"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
          ],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
      ],
    },

    {
      country: t("access.TAIWAN"),
      controlAccountNumber: "123456789012",
      functions: [
        {
          functionName: t("products.function11"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.function12"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname10"),
          docName: "",
          message: "",
          roles: [
            {
              roleName: t("products.role-pa"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.cardmem"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.cardmanager"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.bcamem"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.sysadmin"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
          ],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
      ],
    },

    {
      country: t("access.NEWZEALAND"),
      controlAccountNumber: "123456789012",
      functions: [
        {
          functionName: t("products.functname1"),
          docName: "user2_access1_function1.pdf",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname5"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname6"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.function11"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.function12"),
          docName: "",
          message: "",
          roles: [],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
        {
          functionName: t("products.functname10"),
          docName: "",
          message: "",
          roles: [
            {
              roleName: t("products.role-pa"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.cardmem"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.cardmanager"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.bcamem"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
            {
              roleName: t("products.sysadmin"),
              mmid: "123",
              docName: "user2_access1_function1_role1.jpg",
            },
          ],
          fundingBillingAccount: "",
          maxLimitPerToken: "",
          dailyNumberOfTokens: "",
          maxSpendPerDay: "",
          thresholdAmount: "",
          notificationRecipient: "",
        },
      ],
    },

    {
      country: t("access.UNITEDKINGDOM"),
      marketKey: "UNITEDKINGDOM",
      controlAccountNumber: "123456789012",
      functions: GET_FUNCTION_LIST(t),
    },

    {
      country: t("access.SWEDEN"),
      marketKey: "SWEDEN",
      controlAccountNumber: "123456789012",
      functions: GET_FUNCTION_LIST(t, COUNTRY_NAME.SWEDEN),
    },

    {
      country: t("access.NORWAY"),
      marketKey: "NORWAY",
      controlAccountNumber: "123456789012",
      functions: GET_FUNCTION_LIST(t, COUNTRY_NAME.NORWAY),
    },

    {
      country: t("access.INTERNATIONALEUROCARD"),
      marketKey: "INTERNATIONALEUROCARD",
      functions: GET_FUNCTION_LIST(t, COUNTRY_NAME.INTERNATIONALEUROCARD),
    }
  ];
  return (
    <PersonalDetailsContainer
      history={props.history}
      accesses={accesses}
      modifyUser={modifyUser}
    />
  );
};

export default AddAccessArray;
